export default "__VITE_ASSET__CFTINn8J__"